import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google'; // 1. Import Provider Google
import App from './App';
import './index.css';

// 2. Ambil Client ID dari environment variable (.env)
const clientId = import.meta.env.VITE_GOOGLE_CLIENT_ID;

// Auto-cleanup Service Worker zombie di localhost agar tidak memicu white blank screen
if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    for (const registration of registrations) {
      registration.unregister();
    }
  });
}

// Pengecekan agar tidak error diam-diam jika lupa isi .env
if (!clientId) {
  console.warn("⚠️ Google Client ID belum diisi di .env! Menggunakan placeholder agar halaman Login/Register tidak crash.");
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    {/* 3. Bungkus aplikasi dengan GoogleOAuthProvider.
        Gunakan fallback format google client id agar SDK Google tidak melempar synchronous exception (crash unmount) saat env belum ada */}
    <GoogleOAuthProvider clientId={clientId || "000000000000-dummyfluenesia.apps.googleusercontent.com"}> 
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </GoogleOAuthProvider>
  </React.StrictMode>,
);